import Footer from '../../components/Footer';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <div className="relative z-10 flex flex-col items-center gap-4">
        <h1 className="text-3xl font-bold mt-6">Premiei</h1>
        <p className="text-base text-white/60">Gere apostas inteligentes, analise resultados e confira seus jogos.</p>
        <Link
          to="/express"
          className="px-6 py-3 rounded-xl bg-gradient-to-r from-emerald-500 to-green-600 hover:shadow-2xl hover:shadow-emerald-500/40 transition-all animate-pulse font-bold text-white"
        >
          Aposta EXPRESSA
        </Link>
      </div>
      <div className="absolute bottom-6 left-0 right-0">
        <Footer />
      </div>
    </div>
  );
}
